export interface ReferidosLicenciasReporteStore {}

export const referidosLicenciasReporteStore: (
  state
) => ReferidosLicenciasReporteStore = state => {
  return {};
};
